import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { verifyEmail, verifyEmailAgain } from 'store/actions';
import VerifyEmail from "./VerifyEmail";
import  toastr  from "toastr";
import { FormGroup } from "react-bootstrap";
import { Input } from "reactstrap";
export default function VerifiedEmail() {
  const dispatch = useDispatch();
  // const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated);
  const isAuthenticated = useSelector((state) => state.Login?.isAuthenticated);
  const { token } = useParams();
  const [verify, setVerify] = useState("verifying")
  const [verifyStatus, setVerifyStatus] = useState(false);
  const [alreadyVerified, setAlreadyVerified] = useState(false);
  const [linkExpired, setLinkExpired] = useState(false);
  const [email, setEmail] = useState('');
  const [emailSent, setEmailSent] = useState(false);
  let navigate = useNavigate();
  useEffect(()=>{
    localStorage.clear();
  },[isAuthenticated])
  useEffect(() => {
    if (token) {
      const callback = (res) => {
        if (res.message ===
          "Email already verified") {
          setAlreadyVerified(true)
        }
        if (res.status === "failure") {
          if (res.message === "Link is expired") {
            setLinkExpired(true)
            setVerify("failure")
          }
          else {
            setVerify("failure")
          }
        }
        if (res.status === "success") {
          setVerify("success")
        }
      };
      dispatch(verifyEmail(token, callback));
    }
  }, [dispatch, token]);
  function closedialogBox() {
    setVerifyStatus(false)
    navigate("/login");
  }
  const onChangeHandler = (name) => (e) => {
    let emailData = e.target.value
    setEmail(emailData)
  }
  const onSubmit = () => {
    const callback = (res) => {
      if (res.status === "failure") {
        if (res.message === "Link is expired") {
          setLinkExpired(true)
        }
        else {
          toastr.error(res?.message)
        }
      }
      if (res.status === "success") {
        toastr.success("Email Sent Successfully")
        setEmailSent(true)
        navigate('/login')
      }
    };
    if (token) {
      dispatch(verifyEmailAgain(email, callback))
    }
  }
  return (
    <>
      <div className="EmailVerifyBox verifiedMail">
        <div>
        {verify === "failure" && alreadyVerified === false && emailSent === false ? (
          <img src={'/images/svg/linkexpire.svg'} className="mx-auto mt-3 mb-4" width={400} alt="Email Verification" />
          
        ):  (
          
          <img src={'/images/svg/verifiedEmail.svg'} className="mx-auto mt-3 mb-4" width={400} alt="Email Verification" />
          
        ) }
         
          {alreadyVerified === true && verify === "failure" ? (<><h2>Email already Verified</h2>  <Link className="btn btn-primary px-5 outline-0 border-0 mt-3 orangebtn" to={'/login'}>Back to login</Link></>) : (" ")}
          {verify === "success" ? (<> <h2 className="verified-txt">Your Email Has Been Verified</h2><h2>Successfully</h2>    <Link className="btn btn-primary px-5 outline-0 orangebtn border-0 mt-3" to={'/login'}>Back to login</Link></>) : (" ")}
          {verify === "verifying" ? (<h2 className="verified-txt">Verifying email...</h2>) : (" ")}
          <div>
            
            {verify === "failure" && alreadyVerified === false && emailSent === false ? (
              <>{linkExpired === true ? (<h2>The email verification link has expired.<br></br> Enter your registered email below and click 'Resend' to get a new link</h2>) : (<h2>Verification link has been expired</h2>)}
                <FormGroup className="form-group position-relative w-50 mx-auto mt-3">
                  <Input type="text" id="uploadartNew" placeholder="Enter Your email" onChange={onChangeHandler('email')} name="email" /></FormGroup>
                <button className="btn btn-primary px-5 outline-0 border-0 mt-3 orangebtn" onClick={onSubmit}>Resend Email</button>
              </>
            ) : (<>
              {verify !== "success" && linkExpired !== false ? (
                <>
                  <FormGroup className="form-group position-relative">
                    <Input type="text" id="uploadartNew" placeholder="Enter Your email" onChange={onChangeHandler('email')} name="email" /></FormGroup>
                  <button className="btn btn-primary px-5 outline-0 border-0 mt-3 orangebtn" onClick={onSubmit}>Resend Email</button></>)
                : ("")}
            </>
            )}
          </div>
        </div>
      </div>
    </>
  )
}